export default [
    {status : "NEW", message: "offer created not send to ecn" ,type : "success"},
    {status : "CREATED", message: "Offer created in ecn" ,type : "success"},
    {status : "ORDER_REQ_RECEIVED", message: "Buy request received from ecn" ,type : "success"},
    {status : "CANCELLED", message: "Offer cancelled in ecn" ,type : "error"},
    {status : "FAILED_TO_CANCEL", message: "Offer Cancel failed" ,type : "error"},
    {status : "REJECTED", message: "Offer creation failed in ecn" ,type : "error"},
    {status : "ORDER_RES_SEND", message: "Approve response sent to ecn for buy request" ,type : "success"},
    {status : "ORDER_RES_REJECTED", message: "Reject response sent to ecn for buy request" ,type : "error"},
    {status : "ORDER_RES_REJECT_FAILED", message: "Reject response send Failed" ,type : "error"},
    {status : "ORDER_REQ_TIMEOUT", message: "Buy request timed out" ,type : "error"},
    {status : "EXE_CONF_APPROVED", message: "Approve  response request successful" ,type : "success"},
    {status : "EXE_CONF_REJECTED", message: "Approve  response request Failed" ,type : "error"},
    {status : "FILLED", message: "Filled with given quantity" ,type : "success"},
    {status : "TRADER_CANCELLED", message: "Trader Cancelled the filled offer" ,type : "error"},
    {status : "PARTIAL_FILLED", message: "Partially filled the order" ,type : "success"},
    {status : "PARTIAL_FILLED_CANCEL_FAILED", message: "Partially filled and failed to cancel remaining quantity" ,type : "error"},
    {status : "FAILED_TO_CREATE", message: "Failed to create offer" ,type : "error"}
]


